import styled from "styled-components";
import { BorderStyle } from "../../Form/Utilities/FormDesignConstants";

export const ContainerDivider = styled("div")<{
    lineColorBetweenContainers: string;
    lineWidthBetweenContainers: number;
    lineStyleBetweenContrainers: BorderStyle;
    colGap: number;
}>`
    border: ${(props) =>
        `${props.lineWidthBetweenContainers}px ${props.lineStyleBetweenContrainers} ${props.lineColorBetweenContainers}`};
    width: 100%;
    display: flex;
`;
